import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductTransferOwnershipDocument.Replace.IRequest;
type Response = Api.Core.ProductTransferOwnershipDocument.Replace.IResponse;
type Headers = Api.Core.ProductTransferOwnershipDocument.Replace.IHeaders;
const url = '/api/ProductManagement/ProductTransferOwnershipDocument/:productId/ReplaceFile/:documentId';
export default async function productTransferOwnershipDocumentReplaceApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Pick<Request, 'formFile'>, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { productId: body.productId, documentId: body.documentId }),
    body: { formFile: body.formFile },
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
